import Cookies from 'js-cookie';

$(function() {

  //画面幅が800px以下の時はスマホ用画像を表示
  if(window.parent.screen.width < 800) {
    $('.js-product_img').attr('src', './front/img/product_img_sp.jpg');
  } else {
    $('.js-product_img').attr('src', './front/img/product_img.png');
  }

  //ツールNo.を入力した時
  $('.js-tool_no').keyup(function() {
    const input = $(this);
    const column = $(this).data('column_no');
    const form = $(this).data('form_type');
    const keyword = $(this).val();
    const campaign = $('.js-campaign_flag').val();

    //ツールNo.が空の場合は数量にdisableをかける
    if(keyword != "") {
      $.ajax({
        type: 'GET',
        url: "/campaign/Api/search_tool.php",
        dataType:'html',
        data: {
          mode: form +"_search",
          keyword: keyword,
          column: column,
          campaign: campaign
        },
        success: function(data) {
          input.removeClass("column_error")
          $('.js-datalist_box').remove();
          input.after(
            `<div class="js-datalist_box"></div>`
          );
          $('.js-datalist_box').html(data);
        },
        error: function(data) {
          input.addClass("column_error");
        }
      })
    } else {
      $('.js-'+ form + '_quantity_quantity_value' + column).attr('readonly', true).addClass("column_readonly");
    }
  });

  //ツールNo.からフォーカスを外した時
  $('.js-tool_no').blur(function() {
    const input = $(this);
    const value = $(this).val();
    const column = $(this).data('column_no');
    const form = $(this).data('form_type');
    const campaign = $('.js-campaign_flag').val();

    if(value != "") {
      $.ajax({
        type: 'GET',
        url: "/campaign/Api/get_tool_data.php",
        dataType:'json',
        data: {
          value: value,
          form: form,
          campaign: campaign
        },
        success: function(data) {
          input.removeClass("column_error")
          //フロントに食付と精度の枠が存在するかを判別
          if($('td').hasClass('js-' + form + '_hold_on' + column) && $('td').hasClass('js-' + form + '_accuracy' + column)) {
            Object.keys(data).forEach(function (key) {
              $('.js-'+ form +'_' + key + column).children('p').remove();
              $('.js-'+ form +'_' + key + column).children('input').val(data[key]);
              //標準価格はカンマで区切る
              if(key === "standard_price") {
                $('.js-'+ form +'_' + key + column).append('<p>' + data[key].toLocaleString() + '</p>');
              } else {
                $('.js-'+ form +'_' + key + column).append('<p>' + data[key] + '</p>');
              }
            });
          } else {
            Object.keys(data).forEach(function (key) {
              //食付と精度は除外
              if(key != "hold_on" && key != "accuracy") {
                $('.js-'+ form +'_' + key + column).children('p').remove();
                $('.js-'+ form +'_' + key + column).children('input').val(data[key]);
                //標準価格はカンマで区切る
                if(key === "standard_price") {
                  $('.js-'+ form +'_' + key + column).append('<p>' + data[key].toLocaleString() + '</p>');
                } else {
                  $('.js-'+ form +'_' + key + column).append('<p>' + data[key] + '</p>');
                }
              }
            });
          }
          const totalVal = $('.js-'+ form +'_quantity_value' + column).val();
          calculate_all_total(totalVal, column, form);
          $('.js-'+ form +'_quantity_value' + column).attr('readonly', false).removeClass('column_readonly');
        },
        error: function(data) {
          input.addClass("column_error");
        }
      })
    } else {
      calculate_all_total(value, column, form);

      $('.js-'+ form +'_failed' + column).children('p').remove();
      $('.js-'+ form +'_failed' + column).children('input').val();
      $('.js-'+ form +'_quantity_value' + column).attr('readonly', true).addClass("column_readonly");
    }
  });

  //数量からフォーカスを外した時
  $('.js-quantity').change(function() {
    //数量がマイナスの場合0にする
    if(!$(this).val().match(/^([1-9]\d*|0)$/)) {
      $(this).val(0);
    }

    const quantity = $(this).val();
    const column = $(this).data('column_no');
    const form = $(this).data('form_type');

    calculate_all_total(quantity, column, form);
  });

  //標準価格合計と価格合計を計算
  function calculate_all_total(quantity, column, form) {
    let count = 0;

    if(form == "purchase") {
      count = 11;
    } else if(form == "present") {
      count = 6;
    }

    if(quantity == "") {
      quantity = 0;
    }

    let price = $('.js-'+ form +'_standard_price' + column).children('input').val();
    let total = price * quantity;

    //標準価格合計の代入
    $('.js-'+ form +'_standard_total' + column).children('p').remove();
    $('.js-'+ form +'_standard_total' + column).append('<p>' + total.toLocaleString() + '</p>');
    $('.js-'+ form +'_standard_total' + column).children('input').val(total);

    //標準価格と数量の合計をリセット
    let all_total = 0;
    let all_number_total = 0;

    //各標準価格合計を参照して合計を計算
    for(let $i=1; $i<count; $i++) {
      all_total = all_total + Number($('.js-'+ form +'_standard_total' + $i).children('input').val());
      all_number_total = Number(all_number_total + Number($('.js-'+ form +'_quantity_value' + $i).val()));
    }

    //価格合計の代入
    $('.js-'+ form +'_total').children('p').remove();
    $('.js-'+ form +'_quantity_total').children('p').remove();
    $('.js-'+ form +'_total').children('input').val(all_total);
    $('.js-'+ form +'_total').append('<p>' + all_total.toLocaleString() + '</p>');
    $('.js-'+ form +'_quantity_total').children('input').val(all_number_total);
    $('.js-'+ form +'_quantity_total').append('<p>' + all_number_total + '</p>');
  }

  //PDF出力ボタンが押されたらアラートを表示
  $('.js-form').submit(function() {
    setInterval(function () {
      if(Cookies.get("download") === "complete") {
        // Cookies.remove("download");
        document.cookie = "download=complete; max-age=0";
        alert(`注文書PDF　ご注意点\n・キャンペーンのお申し込みをWEB上で処理するものではありませんのでご注意ください。\n・出力されたPDFをお取り引き先へFAXまたはメール等でご送付ください。`);
      }
    }, 1000);
  });
});
